import { Component, OnDestroy, OnInit } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';
import { UpdateService } from './_services/update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy{

  constructor(
    private sessionStorageService: SessionStorageService,
    private updateService: UpdateService
    ) { }

  ngOnInit() {
    document.addEventListener("visibilitychange", this.handleVisibilityChange.bind(this));
  }
  ngOnDestroy() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange.bind(this));
  }

  handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      const tenantId = JSON.parse(localStorage.getItem('activeTenant'));
      const sessionTenantId = this.sessionStorageService.retrieve('activeTenant');

      if (sessionTenantId != tenantId)
        localStorage.setItem('activeTenant', sessionTenantId);
    }
  }
}
